import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalAusenciaService } from './modal-ausencia.service';
import { DatabaseService } from '@app/database/database.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { Router } from '@angular/router';
import { IMotivosCierre } from '@app/database/models/IMotivosCierre.model';

@Component({
  selector: 'app-modal-ausencia',
  templateUrl: './modal-ausencia.component.html',
  styleUrls: ['./modal-ausencia.component.scss']
})
export class ModalAusenciaComponent implements OnInit {

  constructor(
    private modalAusenciaService: ModalAusenciaService,
    private databaseService: DatabaseService,
    private backgroundSyncService: BackgroundSyncService,
    private messageAlertServices: MessageAlertService,
    private router: Router,) { }

  ngOnInit(): void {
    this.getMotivosCierre();
  }

  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  submitted = false;
  enviandose = false;
  isOnline = true;
  @Output() asistenciaUpdate = new EventEmitter<{}>();
  @Output() closeModalAusente = new EventEmitter<any>();
  @Output() emitCloseExam = new EventEmitter<any>();
  @Input() nombreTrabajador: string;
  @Input() nombreEstudio: string;
  @Input() numeroEstudio: string;
  @Input() fecha: string;
  @Input() hora: string;
  @Input() card: any;
  motivosCierre: IMotivosCierre[];
  selectedMotivoCierre: IMotivosCierre;
  motivo: string = '';
  private _displayModalAusente = true;
  messagesErrorPrevious;
  

  get displayModalAusente() {
    return this._displayModalAusente;
  }

  @Input()
  set displayModalAusente(val) {
    this._displayModalAusente = val;
  }

  showModalAusente(){
    this._displayModalAusente = true;
  }

  closeModalAusentismo(){
    this._displayModalAusente = false;
    this.selectedMotivoCierre = null;
    this.closeModalAusente.emit(false);
  }

  async getMotivosCierre(): Promise<void> {
		const motivosCierreListFromOffline = await this.databaseService.getAllMotivosCierreFromOfflineDB();
		this.motivosCierre = motivosCierreListFromOffline;
	}

  submitAusente(){
    if(this.selectedMotivoCierre){
      this.emitCloseExam.emit(this.selectedMotivoCierre);
      this.closeModalAusentismo();
    }else{
      this.messagesErrorPrevious = [{ severity: 'error', summary: 'Error', detail: 'Seleccione un motivo para continuar.'}];
    }
  }

  buildRequest() {
    const object = {
      userId : this.currentUser.userId,
      username : this.currentUser.username,
      modelId : this.currentUser.modelId,
      tipoEstudio : this.nombreEstudio,
      examenNumero : this.numeroEstudio,
      motivo: this.selectedMotivoCierre.codigo,
    }
    return object;
  }

  returnToExams(ruta?): void {
    this.router.navigate([ruta ? ruta : 'examenes']);
  }


}
